import { render, staticRenderFns } from "./EditTaskGroup.vue?vue&type=template&id=b5247dc0"
import script from "./EditTaskGroup.vue?vue&type=script&lang=js"
export * from "./EditTaskGroup.vue?vue&type=script&lang=js"
import style0 from "./EditTaskGroup.vue?vue&type=style&index=0&id=b5247dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports